import { OfferCard } from "#js/components/OfferCard"
import { html } from "lit"

export class OfferSliderCard extends OfferCard {
  static get properties() {
    return {
      sliderPosition: { type: Number },
    }
  }

  getBubbles() {
    if (this.offer.type === "expert") {
      return super.getBubbles()
    } else {
      return ""
    }
  }

  tracking(body) {
    return html`
      <promotion-item
        promotionId="${this.promotionId}"
        promotionName="${this.promotionName}"
        creativeName="${this.offer.subtitle}"
        creativeSlot="offer-slider-${this.sliderPosition}"
        itemId="${this.offer.type}-${this.offer.id}"
        itemName="${this.offer.title}"
        itemBrand="${this.offer.provider_title}"
        itemCategory="${this.offer.activity_type}"
      >
        ${body}
      </promotion-item>
    `
  }

  firstUpdated() {
    if (!this.offer) {
      console.warn(
        "<offer-slider-card> component rendered without properties assigned.",
      )
    }
  }

  sendSelectItemOfferCard(event, offer) {
    // don't do anything to disable select item
    // @todo: implement view/select tracking component and use on offer card
  }
}

globalThis.customElements.define("offer-slider-card", OfferSliderCard)
